import { ShieldCheck, Wine, Sparkles, Gift } from "lucide-react";

const ICONS = { ShieldCheck, Wine, Sparkles, Gift };

const ITEMS = [
  {
    id: "armed_security",
    label: "Armed Security",
    desc: "Discreet, certified protection.",
    icon: "ShieldCheck",
  },
  {
    id: "champagne",
    label: "Champagne Service",
    desc: "Celebrate the moment in style.",
    icon: "Wine",
  },
  {
    id: "red_carpet",
    label: "Red Carpet Experience",
    desc: "Arrivals worth remembering.",
    icon: "Sparkles",
  },
  {
    id: "custom_decor",
    label: "Custom Décor & VIP",
    desc: "Tailored to your event.",
    icon: "Gift",
  },
];

export const AddOns = () => {
  return (
    <section
      id="addons"
      data-testid="addons-section"
      className="relative py-24 md:py-32 border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-12 gap-8 mb-14 items-end">
          <div className="md:col-span-7">
            <div className="text-[10px] tracking-[0.3em] text-[#E50914] uppercase mb-4">
              ⏤ Elevate The Ride
            </div>
            <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tighter leading-none">
              Add-Ons & VIP Services
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-zinc-400 leading-relaxed text-sm">
              Combine any add-on with your booking. Final pricing confirmed at request review.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {ITEMS.map((i, idx) => {
            const Icon = ICONS[i.icon];
            return (
              <div
                key={i.id}
                data-testid={`addon-card-${i.id}`}
                className="group bg-[#0A0A0A] border border-zinc-800 p-7 hover:border-[#E50914] hover:-translate-y-1 transition-all duration-500 relative overflow-hidden"
              >
                <div className="absolute top-0 right-0 text-[10px] font-mono-data text-zinc-700 p-3">
                  0{idx + 1}
                </div>
                <div className="w-12 h-12 bg-[#E50914]/10 border border-[#E50914]/30 flex items-center justify-center mb-5 group-hover:bg-[#E50914] transition-colors">
                  <Icon className="w-5 h-5 text-[#E50914] group-hover:text-white" strokeWidth={1.5} />
                </div>
                <h4 className="font-display text-lg uppercase tracking-tight">{i.label}</h4>
                <p className="text-sm text-zinc-500 mt-2 leading-relaxed">{i.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
